import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TileSharedComponent } from './tile.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    declarations: [
        TileSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule
    ],
    exports: [
        TileSharedComponent
    ]
})

export class TileSharedModule {}
